import { download, http } from './request'

const PREFIX = '/biz/config/systemPanel/cache'

export interface CacheKeyItem {
  key: string
  type: string
  ttl: number
  ttlText: string
}

export interface CacheKeyPageResult {
  total: number
  db: number
  defaultDb: number
  records: CacheKeyItem[]
}

export interface CacheKeyDetail {
  db: number
  key: string
  type: string
  ttl: number
  ttlText: string
  size: number
  value: string
  truncated?: boolean
}

export async function fetchCacheKeys(params: {
  keyword?: string
  current?: number
  size?: number
}): Promise<CacheKeyPageResult> {
  return http.get<CacheKeyPageResult>(`${PREFIX}/keys`, { params })
}

export async function fetchCacheKeyDetail(key: string): Promise<CacheKeyDetail> {
  return http.get<CacheKeyDetail>(`${PREFIX}/detail`, { params: { key } })
}

export async function deleteCacheKey(key: string): Promise<void> {
  await http.post<void>(`${PREFIX}/delete`, { key })
}

export async function deleteCacheKeys(keys: string[]): Promise<void> {
  await http.post<void>(`${PREFIX}/deleteBatch`, { keys })
}

function safeTxtName(key: string) {
  const name = key.replace(/[\\/:*?"<>|\s]+/g, '_').slice(0, 80)
  return name || 'redis-key'
}

export async function downloadCacheKeyFile(key: string): Promise<void> {
  await download(`${PREFIX}/export`, `${safeTxtName(key)}.txt`, {
    params: { key },
    timeout: 120000,
  })
}

export async function downloadCacheKeysFile(keys: string[]): Promise<void> {
  await download(`${PREFIX}/export`, `redis-keys-${keys.length}.txt`, {
    params: { keys },
    timeout: 120000,
  })
}
